import * as upModel		from "@geotoura/shared/upModel";
import * as commonModel	from "@geotoura/shared/commonModel";

import * as searchText	from "@geotoura/common/util/searchText";

export const getDestinationIdForName = (markers:ReadonlyArray<upModel.Marker>, name:string):commonModel.DestinationId|null => {
	const results =
		markers.filter((candidate) =>
			searchText.matches(candidate.t, name)
		);
	return results.length === 1 ? results[0].id : null;
};

export const getDestinationFromUrl = (location:string):string|null => {
	const m = /.*\/d\/(.*)$/.exec(location);
	return m !== null ? decodeURIComponent(m[1]) : null;
};
